import { post, postJson, get, deleteApi } from '../axios'

const RESOURCE_BASE_PATH = '/autoReplyComment/'

export const getAutoAssessList = p => get(`${RESOURCE_BASE_PATH}`, p)

export const openState = p => postJson(`${RESOURCE_BASE_PATH}open-state`, p);

export const getDetails = id => get(`${RESOURCE_BASE_PATH}templet/${id}`);

export const delAutoAssess = id => deleteApi(`${RESOURCE_BASE_PATH}${id}`)

// 新增/编辑自动回评配置
export const addAutoAssess = p => postJson(`${RESOURCE_BASE_PATH}`, p);